export const SEARCH_FIELD_HEIGHT = 50
export const REMOVE_ALL_BUTTON_HEIGHT = 22
export const PADDING = 8
